export default __webpack_public_path__ + "static/media/tete42.af16cee3.png";